import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/Button';
import CheckboxSmall, { CheckboxSize } from 'components/Checkbox/CheckboxSmall';
import FormContainer from 'components/LoanForm/FormContainer';
import { getBankAccount } from 'selectors/getBankAccount';
import AccountRow from 'components/Verification/Steps/CheckingAccount/SelectAccount/components/AccountRow';
import { getCheckingAccounts } from 'thunks';
import { RootState } from 'handlers';

import styles from './ConfirmAccount.module.scss';

interface ConfirmAccountProps {
  onConfirm: () => Promise<void>;
}

const ConfirmAccount = ({ onConfirm }: ConfirmAccountProps) => {
  const dispatch = useDispatch();
  const { bankAccounts, isLoadingCheckingAccounts } = useSelector(getBankAccount);
  const { application } = useSelector((state: RootState) => state.applicationData!);

  const [hasConfirmed, setHasConfirmed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const account = bankAccounts[0];

  useEffect(() => {
    if (bankAccounts.length === 0 && !isLoadingCheckingAccounts && application?.id) {
      dispatch(getCheckingAccounts({ applicationId: application.id }));
    }
  }, []);

  const handleClick = async () => {
    setIsSubmitting(true);
    await onConfirm();
    setIsSubmitting(false);
  };

  return (
    <FormContainer title="Confirm this is your account">
      {account && (
        <div>
          <AccountRow
            selected={undefined}
            accountName={account.officialName || account.name}
            accountNumber={account.mask}
            accountBalance={account.balance}
          />
        </div>
      )}
      <CheckboxSmall
        className={styles.checkbox}
        name="hasConfirmedOwnerNameMatch"
        label="I confirm I am the owner of this account."
        checked={hasConfirmed}
        size={CheckboxSize.Sm}
        onChange={(event) => setHasConfirmed(event.target.checked)}
      />
      <Button onClick={handleClick} isLoading={isSubmitting} disabled={!hasConfirmed}>
        Next
      </Button>
    </FormContainer>
  );
};

export default ConfirmAccount;
